<form nz-form [formGroup]="formGroup">
    <nz-card>
        <h4>{{ (!!formGroup.get('id')?.value ? "activity-types.detail.edit-title" : "activity-types.detail.add-title") | translate }}</h4>
        <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>{{ "common.name" | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzErrorTip]="nameValidationTemplate">
                <input nz-input [formControl]="formGroup.controls.name" />

                <ng-template #nameValidationTemplate let-control>
                    <app-input-validation [control]="control" [field]="'name'" [errors]="errors"></app-input-validation>
                </ng-template>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>{{ "common.plural-name" | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzErrorTip]="pluralNameValidationTemplate">
                <input nz-input [formControl]="formGroup.controls.pluralName" />

                <ng-template #pluralNameValidationTemplate let-control>
                    <app-input-validation [control]="control" [field]="'pluralName'" [errors]="errors"></app-input-validation>
                </ng-template>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>{{ "common.code" | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzErrorTip]="activityCodeValidationTemplate">
                <input nz-input [formControl]="formGroup.controls.code" />

                <ng-template #activityCodeValidationTemplate let-control>
                    <app-input-validation [control]="control" [field]="'code'" [errors]="errors"></app-input-validation>
                </ng-template>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="24">{{ "common.hasEvaluationForm" | translate }}</nz-form-label>
            <label nz-checkbox [formControl]="formGroup.controls.hasEvaluationForm"></label>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="24">{{ "common.hasTheme" | translate }}</nz-form-label>
            <label nz-checkbox [formControl]="formGroup.controls.hasTheme"></label>
        </nz-form-item>
        <div class="button-container">
            <button *ngIf="!readonly" nz-button nzType="primary" (click)="submit()">
                {{ "common.save" | translate }}
            </button>
        </div>
    </nz-card>
</form>